import React from 'react'

export default function Container({ children, padding }) {
    const p = padding || '10%'
    return (
        <div style={{padding:'0 '+ p}}>
            {children}
        </div>
    )
}